import React from "react";
import { NavLink } from "react-router-dom";
import * as IconlyPack from "react-iconly";
import { useTranslation } from "react-i18next";

var NavBarCoordonnateurMobile = () => {
  const {t} = useTranslation()
  const [activeRessource, setActiveRessource] = React.useState("");
  const [activeAnnuaire, setActiveAnnuaire] = React.useState("");
  const [activeBlog, setActiveBlog] = React.useState("");

  React.useEffect(() => {
    if (
      window.location.pathname === "/blog-coordonnateur" ||
      window.location.pathname === "/categories-coordonnateur"
    ) {
      setActiveBlog("actived");
    } else {
      setActiveBlog("");
    }

    if (
      window.location.pathname === "/documents-coordonnateur" ||
      window.location.pathname === "/guides-coordonnateur" ||
      window.location.pathname === "/catalogue-des-universites-coordonnateur"
    ) {
      setActiveRessource("actived");
    } else {
      setActiveRessource("");
    }

    if (
      window.location.pathname === "/gestion-des-fulbrighters-coordonnateur" ||
      window.location.pathname ===
        "/experts-et-personnes-ressources-coordonnateur" ||
      window.location.pathname === "/institutions-et-partenaires-coordonnateur"
    ) {
      setActiveAnnuaire("actived");
    } else {
      setActiveAnnuaire("");
    }
  }, []);
  return (
    <>
      <li>
        <NavLink
          className="mobile nav-link nav-link-vertival-custom"
          to="/dashboard-coordonnateur"
          activeClassName="actived"
        >
          <IconlyPack.Chart
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="mobile-navlink-label">{t("dashboard")}</span>
        </NavLink>
      </li>
      <li className="nav-item nav-item-vertical-custom">
        <a
          // class="btn nav-link nav-link-vertival-custom arrow-collapse-costom collapsed"
          className={`nav-link nav-link-vertival-custom arrow-collapse-costom collapsed ${activeRessource}`}
          type="button"
          href="#collapseRessources"
          data-toggle="collapse"
          data-target="#collapseRessources"
          aria-expanded="false"
          aria-controls="collapseRessources"
        >
          <IconlyPack.Wallet
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />{" "}
          <span className=" mobile-navlink-label">
            {t("ressource")}
            <i class="fa fa-fw fa-chevron-down"></i>
            <i class="fa fa-fw fa-chevron-right"></i>
          </span>
        </a>
        <div class="collapse" id="collapseRessources">
          <div class="card card-body padding-card">
            <ul>
              <li className="list-style">
                <NavLink
                  className="nav-link nav-link-vertival-custom"
                  to="/documents-coordonnateur"
                >
                  <span className="mobile-navlink-label">{t("document")}</span>
                </NavLink>{" "}
              </li>
              <li className="list-style">
                <NavLink
                  className="nav-link nav-link-vertival-custom"
                  to="/guides-coordonnateur"
                >
                  <span className="mobile-navlink-label">{t("guide")}</span>
                </NavLink>{" "}
              </li>
              <li className="list-style">
                <NavLink
                  className="nav-link nav-link-vertival-custom"
                  to="/catalogue-des-universites-coordonnateur"
                >
                  <span className="mobile-navlink-label">{t("catalogue")}</span>
                </NavLink>{" "}
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li className="nav-item nav-item-vertical-custom">
        <a
          // class="btn nav-link nav-link-vertival-custom arrow-collapse-costom collapsed"
          className={` nav-link nav-link-vertival-custom arrow-collapse-costom collapsed ${activeAnnuaire}`}
          type="button"
          href="#collapseAnnuaire"
          data-toggle="collapse"
          data-target="#collapseAnnuaire"
          aria-expanded="false"
          aria-controls="collapseAnnuaire"
        >
          <IconlyPack.AddUser
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />{" "}
          <span className=" mobile-navlink-label">
            {t("annuaire")}
            <i class="fa fa-fw fa-chevron-down"></i>
            <i class="fa fa-fw fa-chevron-right"></i>
          </span>
        </a>
        <div class="collapse" id="collapseAnnuaire">
          <div class="card card-body padding-card">
            <ul>
              <li className="list-style">
                <NavLink
                  className="nav-link nav-link-vertival-custom"
                  to="/gestion-des-fulbrighters-coordonnateur"
                >
                  <span className="mobile-navlink-label">
                    {t("managing_fulbrighters")}
                  </span>
                </NavLink>{" "}
              </li>
              <li className="list-style">
                <NavLink
                  className="nav-link nav-link-vertival-custom"
                  to="/experts-et-personnes-ressources-coordonnateur"
                >
                  <span className="mobile-navlink-label">
                    {t("experts_resource")}
                  </span>
                </NavLink>{" "}
              </li>
              <li className="list-style">
                <NavLink
                  className="nav-link nav-link-vertival-custom"
                  to="/institutions-et-partenaires-coordonnateur"
                >
                  <span className="mobile-navlink-label">
                    {t("institution_partners")}
                  </span>
                </NavLink>{" "}
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li>
        <NavLink
          className="mobile nav-link nav-link-vertival-custom"
          to="/forum-coordonnateur"
          activeClassName="actived"
        >
          <IconlyPack.Category
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="mobile-navlink-label">Forum</span>
        </NavLink>
      </li>
      {/* <li>
        <NavLink
          className="mobile nav-link nav-link-vertival-custom"
          to="/blog-coordonnateur"
          activeClassName="actived"
        >
          <IconlyPack.AddUser
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="mobile-navlink-label">Blog</span>
        </NavLink>
      </li> */}
      <li className="nav-item nav-item-vertical-custom">
        <a
          // class="btn nav-link nav-link-vertival-custom arrow-collapse-costom collapsed"
          className={`nav-link nav-link-vertival-custom arrow-collapse-costom collapsed ${activeBlog}`}
          type="button"
          data-toggle="collapse"
          href="#collapseBlog"
          data-target="#collapseBlog"
          aria-expanded="false"
          aria-controls="collapseBlog"
        >
          <IconlyPack.Wallet
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />{" "}
          <span className=" mobile-navlink-label">
            {t("blog")}
            <i class="fa fa-fw fa-chevron-down"></i>
            <i class="fa fa-fw fa-chevron-right"></i>
          </span>
        </a>
        <div class="collapse" id="collapseBlog">
          <div class="card card-body padding-card">
            <ul>
              <li className="list-style">
                <NavLink
                  className="nav-link nav-link-vertival-custom"
                  to="/blog-coordonnateur"
                >
                  <span className="mobile-navlink-label">
                    {t("article_management")}
                  </span>
                </NavLink>{" "}
              </li>
              <li className="list-style">
                <NavLink
                  className="nav-link nav-link-vertival-custom"
                  to="/categories-coordonnateur"
                >
                  <span className="mobile-navlink-label">
                    {t("category_management")}
                  </span>
                </NavLink>{" "}
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li>
        <NavLink
          className="mobile nav-link nav-link-vertival-custom"
          to="/reports-coordonnateur"
          activeClassName="actived"
        >
          <IconlyPack.Danger
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="mobile-navlink-label">{t("reports")}</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="mobile nav-link nav-link-vertival-custom"
          to="/incidents&feedbacks-coordonnateur"
          activeClassName="actived"
        >
          <IconlyPack.InfoCircle
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="mobile-navlink-label">{t("incidents")}</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="mobile nav-link nav-link-vertival-custom"
          to="/messages-coordonnateur"
          activeClassName="actived"
        >
          <IconlyPack.Wallet
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="mobile-navlink-label">Messages</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="mobile nav-link nav-link-vertival-custom"
          to="/agenda-coordonnateur"
          activeClassName="actived"
        >
          <IconlyPack.Discovery
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="mobile-navlink-label">Agenda</span>
        </NavLink>
      </li>
      <li>
        <NavLink
          className="mobile nav-link nav-link-vertival-custom"
          to="/profil-coordonnateur"
          activeClassName="actived"
        >
          <IconlyPack.User
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="mobile-navlink-label">{t("my_profil")}</span>
        </NavLink>
      </li>
    </>
  );
};

export default NavBarCoordonnateurMobile;
